import { BznavAppIds } from '../types/common';
import { browser, device, os } from '../utils/device';

export const AUTH_COOKIE_DOMAIN = process.env.NEXT_PUBLIC_ZENV === 'loc' ? 'localhost' : '.bznav.com';
export const ALL_BZNAV_APP_ID: BznavAppIds[] = ['bznav-refund', 'bznav-sena', 'bznav-care'];

export const IS_CLIENT = typeof window !== 'undefined';
export const IS_MOBILE = IS_CLIENT && (device.is('mobile') || device.is('tablet'));
export const IS_ANDROID = IS_CLIENT && os.is('android');
export const IS_IOS = IS_CLIENT && os.is('ios');
export const IS_KAKAO_APP = IS_CLIENT && browser.name?.toUpperCase() === 'KAKAOTALK' && browser.is('inapp');
export const IS_IFRAME = IS_CLIENT && window.self !== window.top;

export const IS_PRODUCTION = process.env.NEXT_PUBLIC_ZENV === 'prd' || process.env.NEXT_PUBLIC_ZENV === 'prod';
